<div class="iframe-dialog-wrap">
    <div class="iframe-header">
        <button class="iframe-dialog-cls-btn" (click)="closeDialog()"><img src="assets/img/close-black-icon.svg" /></button>
    </div>
    <iframe #iframe id="storyFrame" (load)="iframeLoaded()" allow="camera;geolocation;payment;" loading="lazy" class="iframe-class" [src]="redirectionUrl | safeurl">
        <p>Your browser does not support iframes.</p>
    </iframe>
</div>
